import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const insuranceDetailsContainerStyles = css({
  borderRadius: theme.borderRadius.medium,
  border: `1px solid ${theme.colors.neutral20}`,
  padding: theme.spacing(3),
  backgroundColor: theme.colors.white,
});

export const sectionInfoContainerStyles = css({
  marginTop: theme.spacing(1),
  display: 'flex',
  gap: theme.spacing(4),
});

export const insuranceDetailsSectionStyles = css({
  width: '100%',
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateRows: '1fr, 1fr',
  marginBottom: theme.spacing(3),
});

export const insuranceDetailsOverflowStyles = css({
  maxHeight: '210px',
  overflowY: 'auto',
});
